/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsColorCollection,
    SharedserviceMelcoModelsColorCollectionFromJSON,
    SharedserviceMelcoModelsColorCollectionFromJSONTyped,
    SharedserviceMelcoModelsColorCollectionToJSON,
    SharedserviceMelcoModelsCustomWarning,
    SharedserviceMelcoModelsCustomWarningFromJSON,
    SharedserviceMelcoModelsCustomWarningFromJSONTyped,
    SharedserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsGenericList1MelcoModelsColorCollection
 */
export interface SharedserviceMelcoModelsGenericList1MelcoModelsColorCollection {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsColorCollection>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsColorCollection
     */
    list: Array<SharedserviceMelcoModelsColorCollection>;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCustomWarning>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsColorCollection
     */
    warning_list?: Array<SharedserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoModelsColorCollection
     */
    total: number;
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsColorCollectionFromJSON(json: any): SharedserviceMelcoModelsGenericList1MelcoModelsColorCollection {
    return SharedserviceMelcoModelsGenericList1MelcoModelsColorCollectionFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsColorCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsGenericList1MelcoModelsColorCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(SharedserviceMelcoModelsColorCollectionFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(SharedserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function SharedserviceMelcoModelsGenericList1MelcoModelsColorCollectionToJSON(value?: SharedserviceMelcoModelsGenericList1MelcoModelsColorCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(SharedserviceMelcoModelsColorCollectionToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(SharedserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


